import { render, staticRenderFns } from "./CommentsMixedListTable.vue?vue&type=template&id=c64bb374&scoped=true&"
import script from "./CommentsMixedListTable.vue?vue&type=script&lang=ts&"
export * from "./CommentsMixedListTable.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsMixedListTable.vue?vue&type=style&index=0&id=c64bb374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64bb374",
  null
  
)

export default component.exports